"use client";

import { useNewUniversity } from "./UniversityProvider";
import { getUniversityContent } from "../universityPack/content";
import { useRouter } from "next/router";
import { useAuth } from "@/lib/supabase/AuthContext";

const SIGNED_IN_APP_PREFIXES = [
    "/dashboard",
    "/assignments",
    "/study",
    "/year-at-a-glance",
    "/lounge",
    "/wellbeing",
    "/profile",
    "/planner",
    "/quiz",
];

function isSignedInAppRoute(pathname: string): boolean {
    return SIGNED_IN_APP_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function useUniversityContent() {
    const { activePack, isPathOverride } = useNewUniversity();
    const router = useRouter();
    const { user } = useAuth() || { user: null };

    // If we are on a generic path (e.g. /, /about), we MUST use core content
    // to ensure the platform home is generic, even if a pack is "active" in cookies.
    if (!isPathOverride && !(user && isSignedInAppRoute(router.pathname))) {
        return getUniversityContent("core");
    }

    return getUniversityContent(activePack.slug);
}
